'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};

exports.default = teal;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/colors/teal.js
// module id = 704
// module chunks = 0